import { EditorThemeClasses } from 'lexical';

export const theme: EditorThemeClasses = {
  text: {
    underline: 'MarkdownEditorTheme__text-underline',
    strikethrough: 'MarkdownEditorTheme__text-strikethrough',
  },
  list: {
    nested: {
      listitem: 'MarkdownEditorTheme__nested-list-item',
    },
  },
  table: 'MarkdownEditorTheme__table',
  tableRow: 'MarkdownEditorTheme__tableRow',
  tableCell: 'MarkdownEditorTheme__tableCell',
  tableCellHeader: 'MarkdownEditorTheme__tableCellHeader',
};
